// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "58995" ? "__federation_expose_HelpDrawer" : chunkId) + ".css"
}